module.exports = __webpack_public_path__ + "static/media/arshiya_kazi.a712cb45.png";